export default __webpack_public_path__ + "static/media/mario8.b31e19d3.jpg";